import { createContext } from 'react';
import { UpdateContractInput } from '@/graphql/generated';

export type UpdateContractFormModalContextProps = {
  closeModal: () => void
  openModal: (contractData?: UpdateContractInput) => void
  contractData: UpdateContractInput | null
  isOpen: boolean
}

export const UpdateContractFormModalContext = createContext<UpdateContractFormModalContextProps | null>(null)